import { frontendURL } from '../../../../helper/URLHelper';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const SubscriptionSettings = () => import('./SubscriptionSettings.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/usage'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'usage_settings',
          component: SubscriptionSettings,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
